<template>
    <div v-if="isLoading" class="loader-container">
        <div class="loader">
            <!-- <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>-->
            <h1 class="text-white" v-text="loadingText" v-if="loadingText"></h1>
            <fa :icon="['fas', 'spinner']" spin size="2x"></fa>
        </div>
    </div>
</template>

<script>

export default {
  name: 'ScreenLoader',
  props: ['isLoading', 'loadingText'],
  components: {},
  data () {
    return {

    }
  }
}
</script>

<style lang="less" scoped>
    .loader-container {
        z-index: 12;
        position: fixed;
        width: 100vw;
        height: var(--real-vh);
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(0, 0, 0, 0.21);

        .loader {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            h1 {
                font-weight: 600;
                font-size: 20px;
            }
        }
    }
</style>
